import { useModal } from '@panel/commons/hooks';
import React, { useEffect } from 'react';
import { GeneralError } from './generalError';
import { Modal } from './ModalWrapper';

const ModalDispatcher = React.memo(() => {
  const { isShowing, toggleValue } = useModal();
  const onClose = () => {
    toggleValue(false);
  };
  useEffect(() => {
    if (isShowing) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isShowing]);

  return (
    isShowing && (
      <Modal>
        <GeneralError openModal={isShowing} onClose={onClose} handleClick={onClose} />
      </Modal>
    )
  );
});

export { ModalDispatcher };
